import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { AllSecondaryDeploymentReport } from "../../../Apis/TransferStationReport/secondaryDeploymentTransactionReportApi";
import TableComponent from "../../../Common/TableComponent/tableComponent";
import ExcelJS from "exceljs";
import isGHMC, { getCurrentDateTime1 } from "../../../Common/helper/helpar";
import { TableLoader } from "../../../Common/ShimmerLoader";
import { exportToPDF } from "../../../../utils/exportToPDF";
import axiosInstance from "../../../../Hooks/axoisInstance";
import { API_BASE_URL1 } from "../../../Services/baseApiUrl";
import SmallLoader from "../../../../Hooks/SmallLoader";
import { GetZone, GetVehicleType } from "../../../Apis/organizationApi";
import Select from "react-select";

const getToken = () => {
  return localStorage.getItem("token");
};

const SecondaryCollectionDeploymentReport = ({ t }) => {
  const headers = [
    "vehicleUid",
    "vehicleNumber",
    "zone",
    // "circle",
    "ward",
    "vehicleType",
    "ownerType",
    "sdincharge",
    "shift",
    "driverName",
    "deploymentDate",
    "latitude",
    "longitude",
    "address",
    "image",
  ];

  const [getAllTripsTonnage, setAllTripsTonnage] = useState([]);
  const [startDate, setStartDate] = useState(getStartOfCurrentDate());
  const [endDate, setEndDate] = useState(getCurrentDateTime());
  const [vehicleNumber, setVehicleNumber] = useState("");
  const [allZones, setAllZones] = useState("");
  const [zoneId, setZoneId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const isProd = isGHMC();
  const [vehicleTypeDetails, setVehicleTypeDetails] = useState([]);
  const [isExcelLoading, setIsExcelLoading] = useState(false);
const [isExcelWithImagesLoading, setIsExcelWithImagesLoading] = useState(false);
const [selectedVehicleTypes, setSelectedVehicleTypes] = useState([]);
    const fetchAllVehicleTypeData = async () => {
      try {
          const vehicleTypesData = await GetVehicleType();
          setVehicleTypeDetails(vehicleTypesData);
      } catch (error) {
          console.error("Error fetching vehicle types:", error);
      }
  };
  const getSelectedVehicleTypeIds = () => selectedVehicleTypes.map(v => v.value);

  const fetchAllZoneData = async () => {
    try {
      const zonesData = await GetZone();
      const delhiZones = (Array.isArray(zonesData) ? zonesData : []).filter(
        (zone) =>
          zone.isActive !== false &&
          String(zone.zoneName || "").toLowerCase().includes("delhi")
      );
      setAllZones(delhiZones);
    } catch (error) {
      console.error("Error fetching initial data:", error);
    }
  };

  useEffect(() => {
    fetchAllZoneData();
    fetchAllVehicleTypeData();
    fetchTripsTonnageData(startDate, endDate, zoneId, vehicleNumber);
  }, []);

  useEffect(() => {
    const zones = Array.isArray(allZones) ? allZones : [];
    if (zones.length === 0) return;

    setZoneId((currentZoneId) =>
      currentZoneId ? currentZoneId : String(zones[0].zoneId)
    );
  }, [allZones]);

  const fetchTripsTonnageData = async (
    startDate,
    endDate,
    zoneId,
    vehicleNumber,
    vehicleTypeIds = [],
  ) => {
    try {
      setIsLoading(true);
      const response = await AllSecondaryDeploymentReport(
        startDate,
        endDate,
        zoneId,
        "",
        "",
        "",
        vehicleTypeIds.join(","),
        vehicleNumber,
       
      );
      const formattedData = response.data.map((item) => ({
        ...item,
        vehicleUid: item.vehicleUuid || "N/A",
        image: item.vehicleImageUrl || "N/A",
        sdincharge: item.secondaryDeploymentInchargeName || "N/A",
        routeSupervisor: item.isSupervisorDeployed || "N/A",
        deploymentDate: formatDateForDisplay(item.deploymentDate || "N/A"),
        latitude: item.scannedLatitude || "N/A",
        longitude: item.scannedLongitude || "N/A",
        address: item.address || "N/A",
        zone: item.zoneName || "N/A",
        ward: item.circleName || "N/A",
        image: item.vehicleImageUrl || "N/A",
        vehicleType: item.vehicleTypeName || "N/A",
        ownerType: item.ownerTypeName || "N/A",
        shift: item.shiftName || "N/A",
        routeCode: item.routeCodes || "N/A",
      }));
      setAllTripsTonnage(formattedData);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    fetchTripsTonnageData(startDate, endDate, zoneId, vehicleNumber, getSelectedVehicleTypeIds());
  };

  // Function to format dates for display
  const formatDateForDisplay = (dateString) => {
    const date = new Date(dateString);
    const options = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    };
    return date.toLocaleString("en-GB", options).replace(",", "");
  };

  const options = { day: "numeric", month: "numeric", year: "numeric" };
  const generationTime = ` ${new Date().toLocaleString("en-GB", options).replace(/\//g, "/")}`;

  // clinte side
  const downloadAsExcel = async () => {
    setIsExcelLoading(true);
    try {
    const currentDate = new Date();
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Deployment Transactions");
    const boldFont = { bold: true };

    /* ---------- HEADER ---------- */
    worksheet.addRow([
      "",
      "",
      `Report Generated on: ${generationTime}, ${formattedTime}`,
    ]);
    worksheet.mergeCells(1, 2, 1, 10);
    worksheet.getCell(1, 2).value = `Report Generated on: ${generationTime}, ${formattedTime}`;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };

    worksheet.addRow(["", "", "Deployment Transaction Reports", ""]);
    worksheet.mergeCells(2, 2, 2, 10);
    worksheet.getCell(2, 2).value = "Deployment Transaction Reports";
    worksheet.getCell(2, 2).font = { bold: true, size: 14 };
    worksheet.getCell(2, 2).alignment = { horizontal: "center" };

    worksheet.addRow([""]);

    /* ---------- TABLE HEADERS ---------- */
    const headerRow = worksheet.addRow([
      "S.No",
      "Vehicle UID",
      "Vehicle Number",
      "Zone",
      "Ward",
      "Vehicle Type",
      "Owner Type",
      "SD Incharge Name",
      "Shift",
      "Driver Name",
      "Deployment Date",
      "Latitude",
      "Longitude",
      "Address",
    ]);

    headerRow.eachCell((cell) => {
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
      cell.alignment = { vertical: "middle", horizontal: "left" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF003366" },
      };
    });

    /* ---------- DATA + IMAGES ---------- */
    for (let i = 0; i < getAllTripsTonnage.length; i++) {
      const item = getAllTripsTonnage[i];

      worksheet.addRow([
        i + 1,
        item.vehicleUuid ?? "N/A",
        item.vehicleNumber ?? "N/A",
        item.zoneName ?? "N/A",
        item.circleName ?? "N/A",
        item.vehicleTypeName ?? "N/A",
        item.ownerTypeName ?? "N/A",
        item.secondaryDeploymentInchargeName ?? "N/A",
        item.shiftName ?? "N/A",
        item.driverName ?? "N/A",
        formatDateForDisplay(item.deploymentDate) ?? "N/A",
        item.scannedLatitude ?? "N/A",
        item.scannedLongitude ?? "N/A",
        item.address ?? "N/A",
      ]);
    }

    /* ---------- COLUMN WIDTHS ---------- */
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 25 },
      { width: 15 },
      { width: 20 },
      { width: 20 },
      { width: 15 },
      { width: 15 },
      { width: 40 },
    ];

    /* ---------- SAVE FILE ---------- */
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "DeploymentTransactionReport.xlsx";
    a.click();
    URL.revokeObjectURL(url);
    } finally {
      setIsExcelLoading(false);
    }
  };
  // server side
  const dowanloadExcel = async (withImages = false ) => {
         if (withImages) {
          setIsExcelWithImagesLoading(true);
          } else {
              setIsExcelLoading(true);
          }
    try {
      const response = await axiosInstance.get(
        `${API_BASE_URL1}MasterCreate/Downloadexcel`,
        {
          params: {
            startDate,
            endDate,
            ZoneId: zoneId,
            VehicleNumber: vehicleNumber,
              VehicleTypeIds: getSelectedVehicleTypeIds().join(","), 
            withImages,
          },
          headers: {
            Authorization: `Bearer ${getToken()}`,
          },
          responseType: "blob", // 🔥 VERY IMPORTANT
        },
      );

      // ✅ Create downloadable file
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = "Deployment Transaction Report.xlsx"; // or backend filename
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Excel download failed", error);
    } finally {
      setIsExcelLoading(false);
      setIsExcelWithImagesLoading(false);
    }
  };
//  pdf clinte sidde
  const exportPdf = async () => {
    await exportToPDF({
      fileName: "Deployment_Transaction_Report",
      title: "Deployment Transaction Reports",
      generatedOnText: `Report Generated on: ${generationTime}, ${getCurrentDateTime1()}`,
      headFillColor: [0, 51, 102],
      headTextColor: [255, 255, 255],
      data: getAllTripsTonnage,
      columns: [
        {
          header: "S.No",
          accessor: (_row, index) => index + 1,
          width: 10,
        },
        {
          header: "Vehicle UID",
          accessor: (row) => row.vehicleUuid ?? "N/A",
          width: 30,
        },
        {
          header: "Vehicle Number",
          accessor: (row) => row.vehicleNumber ?? "N/A",
          width: 25,
        },
        {
          header: "Zone",
          accessor: (row) => row.zoneName ?? "N/A",
          width: 22,
        },
        {
          header: "Ward",
          accessor: (row) => row.circleName ?? "N/A",
          width: 22,
        },
        {
          header: "Vehicle Type",
          accessor: (row) => row.vehicleTypeName ?? "N/A",
          width: 25,
        },
        {
          header: "Owner Type",
          accessor: (row) => row.ownerTypeName ?? "N/A",
          width: 25,
        },
        {
          header: "SD Incharge Name",
          accessor: (row) => row.secondaryDeploymentInchargeName ?? "N/A",
          width: 35,
        },
        {
          header: "Shift",
          accessor: (row) => row.shiftName ?? "N/A",
          width: 22,
        },
        {
          header: "Driver Name",
          accessor: (row) => row.driverName ?? "N/A",
          width: 30,
        },
        {
          header: "Deployment Date",
          accessor: (row) => formatDateForDisplay(row.deploymentDate) ?? "N/A",
          width: 28,
        },
        {
          header: "Latitude",
          accessor: (row) => row.scannedLatitude ?? "N/A",
          width: 22,
        },
        {
          header: "Longitude",
          accessor: (row) => row.scannedLongitude ?? "N/A",
          width: 22,
        },
        {
          header: "Address",
          accessor: (row) => row.address ?? "N/A",
          width: 60,
        },
      ],
      landscape: true, // REQUIRED for many columns
    });
  };

  return (
    <>
      {isLoading ? (
        <TableLoader height={500} />
      ) : (
        <div style={{ width: "100%" }}>
          <div className="content">
            <div className="page-content">
              <h4 className="text-start mb-3">
                {t("Deployment Transaction Report")} (
                {formatDateForDisplay(startDate)} to{" "}
                {formatDateForDisplay(endDate)}) (at {getCurrentDateTime1()})
              </h4>
              <div className="card">
                <div className="card-body p-3">
                  <div className="row align-items-end">
                    <div className="col-md-12">
                      <form onSubmit={handleFormSubmit}>
                        <div className="row" style={{ textAlign: "left" }}>
                          <div className="col-md-2">
                            <label>From Date & Time:</label>
                            <input
                              type="datetime-local"
                              name="FromDate"
                              style={inputStyle}
                              value={startDate}
                              className="form-control"
                              max={endDate ? endDate : getCurrentDateTime()}
                              onChange={(e) => setStartDate(e.target.value)}
                            />
                          </div>
                          <div className="col-md-2">
                            <label>To Date & Time:</label>
                            <input
                              type="datetime-local"
                              name="ToDate"
                              style={inputStyle}
                              value={endDate}
                              className="form-control"
                              min={startDate}
                              max={getCurrentDateTime()}
                              onChange={(e) => setEndDate(e.target.value)}
                            />
                          </div>
                          <div className="col-md-2">
                            <label>Vehicle Number</label>
                            <input
                              type="text"
                              name="vehicleTypeCode"
                              style={inputStyle}
                              placeholder="Vehicle Number"
                              className="form-control"
                              value={vehicleNumber}
                              onChange={(e) => {
                                setVehicleNumber(
                                  e.target.value.replace(/\s+/g, ""),
                                );
                              }}
                            />
                          </div>
                           <div className="col-md-3">
                            <label htmlFor="VehicleTypeId">Vehicle Type</label>
                            <Select
                                isMulti
                                className="basic-multi-select"
                                classNamePrefix="select"
                                name="vehicleTypes"
                                options={vehicleTypeDetails
                                    .filter((v) => v.isActive)
                                    .map((v) => ({ value: v.vehicleTypeId, label: v.vehicleTypeName }))}
                                value={selectedVehicleTypes}
                                onChange={(selected) => setSelectedVehicleTypes(selected || [])}
                                placeholder="Select Vehicle Types"
                                isClearable
                            />
                        </div>
                          <div className="col-md-2">
                            <label htmlFor="ZoneId">Zone:</label>
                            <select
                              name="ZoneId"
                              className="form-select"
                              value={zoneId}
                              onChange={(e) => setZoneId(e.target.value)}
                            >
                              {Array.isArray(allZones) &&
                                allZones.map((zone) => (
                                  <option
                                    key={zone.zoneId}
                                    value={zone.zoneId}
                                  >
                                    {zone.zoneName}
                                  </option>
                                ))}
                            </select>
                          </div>
                          <div className="col-md-5">
                            <div className="d-flex gap-3 justify-content-between">
                              <button
                                type="submit"
                                className={`btn mt-4 ${isProd ? "search-ghmc" : "search-swm"}`}
                              >
                                Search
                              </button>
                       

                              <button
                          className="btn btn-excel ms-auto mt-4"
                          onClick={downloadAsExcel}
                        >
                          {isExcelLoading ? <SmallLoader /> : <span>
                            <i className="fa-solid fa-file-excel me-1 icon-container"></i>
                            Excel
                          </span>}
                        </button>

                        <button
                          className="btn btn-excel ms-auto mt-4"
                          onClick={() => dowanloadExcel(true)}
                        >
                          {isExcelWithImagesLoading ? <SmallLoader /> : <span>
                            <i className="fa-solid fa-file-excel me-1 icon-container"></i>
                            Excel + Images
                          </span>}
                        </button>

                              <button
                                className="btn btn-excel ms-auto mt-4"
                                onClick={exportPdf}
                              >
                                <i className="fa-solid fa-file-excel me-1 icon-container"></i>{" "}
                                Pdf
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>

                  <div className="mt-3">
                    <div className="">
                      <TableComponent isLoading={isLoading}
                        DataFetchURL={getAllTripsTonnage}
                        headers={headers}
                        imgField="image"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

// Function to get the start of the current date (00:00 AM)
const getStartOfCurrentDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}T00:00`;
};

// Function to get current date and time in the required format
const getCurrentDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hour = String(now.getHours()).padStart(2, "0");
  const minute = String(now.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hour}:${minute}`;
};

// Styles for input and button
const inputStyle = {
  border: "1px solid #E2E2E2",
  padding: "15px",
};

const buttonStyle = {
  border: "1px solid #E2E2E2",
  borderRadius: "5px",
  color: "#fff",
};

export default withTranslation()(SecondaryCollectionDeploymentReport);
